import { marked } from "marked";
import { getClaimStatus } from "@/utils/claimStatus";

export default {
  data() {
    return {
      user: null,
      singleclaim: "",
      comments: "",
      remarks: "",
      remark_selected: "",
      shownotes: false,
      updateprice_vet: false,
      updateprice_ver: false,
      listprice: true,
      facility: "",
      clientdetail: "",
      selected_service: "",
      rejectingServiceId: "",
      body: "",
      modalVerdict: "",
      modalCommentBody: "",
      showManualPrice: false,
      calc: { dose: 1, frequency: 1, days: 1 },
      claimdetails: { paymentorders: [] },
      prepared_by: "",
      singlservicemodal: {
        service: { price: 0 },
        dose: 1,
        frequency: 1,
        days: 1,
      },
      show: false,
      isLoading: false,
      fullPage: true,
      agency_id: "",
      claimSummary: null,
      summaryLoading: false,
      vetLayers: ["A", "C"],
      vetResults: null,
      vetLoading: false,
      vetApplying: false,
      // HIVA TRACE (layer C): options sent with the analysis, and the claim's stored results.
      hivaCheckOptions: [
        { value: "price", label: "Price vs tariff" },
        { value: "dosage", label: "Dosage" },
        { value: "eligibility", label: "Eligibility" },
        { value: "drug_flags", label: "Drug flags" },
      ],
      hivaChecks: ["price", "dosage", "eligibility", "drug_flags"],
      hivaIncludeAi: true,
      hivaForce: false,
      hivaHistory: [],
      hivaHistoryLoading: false,
      hivaView: null,
    };
  },

  beforeMount() {
    this.axios.get(`/api/v1/auth/remarks/95930`).then((response) => {
      this.remarks = response.data;
    });
  },

  watch: {
    '$route.params.id'(newId, oldId) {
      if (newId !== oldId) {
        this.getClaim();
      }
    },
  },

  computed: {
    // HIVA TRACE costs credit and sends claim data out, so the backend allows it for agency staff only.
    canUseHiva() {
      return !!this.user && (this.user.type === "shis" || this.user.type === "employee");
    },

    // The HIVA reply shown in the modal: the one just run, or a stored one picked from the history.
    hivaReport() {
      if (this.hivaView) return this.hivaView.response || null;
      return this.vetResults && this.vetResults.external_api_raw ? this.vetResults.external_api_raw : null;
    },

    claimStatus() {
      return getClaimStatus(this.claimdetails);
    },

    calculateTotal() {
      const unit_price =
        this.singlservicemodal.service != null
          ? this.singlservicemodal.service.price
          : this.singlservicemodal.drug.price;
      return unit_price * this.calc.dose * this.calc.frequency * this.calc.days;
    },

    queueIds() {
      const q = this.$route.query.queue;
      return q ? q.split(',').map(Number) : [];
    },
    queuePosition() {
      return this.queueIds.indexOf(Number(this.$route.params.id));
    },
    nextId() {
      const ids = this.queueIds;
      return this.queuePosition + 1 < ids.length ? ids[this.queuePosition + 1] : null;
    },
    prevId() {
      return this.queuePosition > 0 ? this.queueIds[this.queuePosition - 1] : null;
    },
  },

  methods: {
    goToQueue(id) {
      this.$router.push({
        path: `/claim/${id}`,
        query: this.$route.query,
      });
    },

    // After verifying/vetting, move on to the next queued claim so the
    // reviewer isn't dropped back to the list after every action.
    goToNextOrList() {
      if (this.nextId) {
        this.goToQueue(this.nextId);
      } else {
        this.$router.push(`/all-claims`);
      }
    },

    parseMarkdown(text) {
      return text ? marked(text) : "";
    },

    acceptServiceCost(service, type) {
      if (type === "vet") {
        service.vetted_price = service.cost;
      } else {
        service.verified_price = service.cost;
      }
      this.updateServicePrice(service);
    },

    acceptVetAmount(service) {
      service.verified_price = service.vetted_price;
      this.updateServicePrice(service);
    },

    async acceptAllVetAmounts() {
      if (!confirm("Set verified amount = vetted amount for all services?")) return;
      try {
        await Promise.all(
          this.singleclaim.services.map((s) =>
            this.axios.post("/api/v1/auth/claim_service/update-cost", {
              claims_service_id: s.id,
              vetted_price: s.vetted_price,
              verified_price: s.vetted_price,
            }).then(() => { s.verified_price = s.vetted_price; })
          )
        );
        this.getClaim();
        this.$toasted.info("All verified amounts updated!", { position: "top-center", duration: 3000 });
      } catch {
        this.$toasted.error("Some updates failed. Please try again.", { position: "top-center", duration: 4000 });
      }
    },

    remarkService(service) {
      this.selected_service = service.id;
    },

    startRejectService(service) {
      this.rejectingServiceId = service.id;
      this.remark_selected = "";
    },

    cancelRejectService() {
      this.rejectingServiceId = "";
      this.remark_selected = "";
    },

    confirmRejectService(service) {
      if (!this.remark_selected) {
        this.$toasted.error("Please select a remark for the rejection.", { position: "top-center", duration: 3000 });
        return;
      }
      if (!confirm("Reject this service? Vetted and verified amounts will be set to 0.")) return;

      this.axios
        .post(`/api/v1/auth/claim_service/update-cost`, {
          claims_service_id: service.id,
          vetted_price: 0,
          verified_price: 0,
        })
        .then(() =>
          this.axios.put(`/api/v1/auth/claim_service/${service.id}`, {
            user_id: this.user.id,
            claims_id: this.$route.params.id,
            services_id: service.services_id,
            drugs_id: service.drugs_id,
            cost: service.cost,
            remark_id: this.remark_selected,
          })
        )
        .then(() => {
          this.rejectingServiceId = "";
          this.remark_selected = "";
          this.getClaim();
          this.$toasted.success("Service rejected successfully!", { position: "top-center", duration: 3000 });
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Failed to reject service.", { position: "top-center", duration: 3000 });
        });
    },

    readycommentService(service) {
      this.selected_service = service.id;
      this.show = true;
    },

    getClaim() {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      return this.axios
        .get(`/api/v1/auth/detailedClaim/${this.$route.params.id}`)
        .then((response) => {
          this.singleclaim = response.data;
          this.comments = response.data.comments;
          this.claimdetails = response.data.singleclaim[0];
          this.axios
            .get(`/api/v1/auth/user/zam/${response.data.singleclaim[0].user_id}`)
            .then((res) => {
              this.prepared_by = res.data.user;
            });
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = true;
        });
    },

    // Re-point the open side-panel at its own service after a refetch, so
    // edits made from inside the panel (verdict, comment, price) show up
    // without the user having to close and reopen it.
    resyncServiceModal(serviceId) {
      if (!this.singleclaim || !this.singleclaim.services) return;
      const fresh = this.singleclaim.services.find((s) => s.id === serviceId);
      if (fresh) {
        this.singlservicemodal = fresh;
        this.calc = { dose: fresh.dose, frequency: fresh.frequency, days: fresh.days };
        this.modalVerdict = fresh.remark ? fresh.remark.id : "";
      }
    },

    addComment() {
      const payload =
        this.selected_service !== ""
          ? { user_id: this.user.id, claim_service_id: this.selected_service, body: this.body }
          : { user_id: this.user.id, claim_id: this.$route.params.id, body: this.body };

      this.axios.post(`/api/v1/auth/addComment`, payload).then(() => {
        this.getClaim();
        this.show = false;
        this.selected_service = "";
        this.body = "";
        this.$toasted.info("Added successfully!", { position: "top-center", duration: 3000 });
      });
    },

    updateService(service) {
      this.axios
        .put(`/api/v1/auth/claim_service/${service.id}`, {
          user_id: this.user.id,
          claims_id: this.$route.params.id,
          services_id: service.services_id,
          drugs_id: service.drugs_id,
          cost: service.cost,
          remark_id: this.remark_selected,
        })
        .then(() => {
          this.getClaim().then(() => this.resyncServiceModal(service.id));
          this.show = false;
          this.selected_service = "";
          this.remark_selected = "";
          this.$toasted.info("Updated successfully!", { position: "top-center", duration: 3000 });
        });
    },

    // Verdict + comment forms in the service side panel operate on
    // singlservicemodal directly, independent of the row-level dropdown state.
    saveModalVerdict() {
      if (!this.modalVerdict) {
        this.$toasted.error("Please select a verdict.", { position: "top-center", duration: 3000 });
        return;
      }
      const service = this.singlservicemodal;
      this.axios
        .put(`/api/v1/auth/claim_service/${service.id}`, {
          user_id: this.user.id,
          claims_id: this.$route.params.id,
          services_id: service.services_id,
          drugs_id: service.drugs_id,
          cost: service.cost,
          remark_id: this.modalVerdict,
        })
        .then(() => {
          this.getClaim().then(() => this.resyncServiceModal(service.id));
          this.$toasted.info("Verdict saved!", { position: "top-center", duration: 3000 });
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Failed to save verdict.", { position: "top-center", duration: 3000 });
        });
    },

    addModalComment() {
      if (!this.modalCommentBody.trim()) {
        this.$toasted.error("Please write a comment first.", { position: "top-center", duration: 3000 });
        return;
      }
      const service = this.singlservicemodal;
      this.axios
        .post(`/api/v1/auth/addComment`, {
          user_id: this.user.id,
          claim_service_id: service.id,
          body: this.modalCommentBody,
        })
        .then(() => {
          this.modalCommentBody = "";
          this.getClaim().then(() => this.resyncServiceModal(service.id));
          this.$toasted.info("Comment added!", { position: "top-center", duration: 3000 });
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Failed to add comment.", { position: "top-center", duration: 3000 });
        });
    },

    // Fills the given price field (vetted_price / verified_price) with
    // dose × frequency × days × unit price, then saves both price fields.
    applyCalcToPrice(field) {
      this.singlservicemodal[field] = this.calculateTotal;
      this.updateServicePrice(this.singlservicemodal);
    },

    updateServicePrice(service) {
      this.axios
        .post(`/api/v1/auth/claim_service/update-cost`, {
          claims_service_id: service.id,
          vetted_price: service.vetted_price,
          verified_price: service.verified_price,
        })
        .then(() => {
          this.getClaim().then(() => this.resyncServiceModal(service.id));
          this.show = false;
          this.selected_service = "";
          this.$toasted.info("Cost updated successfully!", { position: "top-center", duration: 3000 });
        });
    },

    verifyClaim() {
      if (confirm("Are you sure you want to mark as verified?")) {
        this.axios
          .post(`/api/v1/auth/verify-claims/${this.$route.params.id}`, { claim_level: "Verification" })
          .then(() => {
            this.goToNextOrList();
            this.$toasted.info("Verified successfully!", { position: "top-center", duration: 3000 });
          });
      }
    },

    vetClaim() {
      if (confirm("Are you sure you want to mark as vetted?")) {
        this.axios
          .post(`/api/v1/auth/checked-claims/${this.$route.params.id}`, { claim_level: "HMO" })
          .then(() => {
            this.goToNextOrList();
            this.$toasted.info("Vetted successfully!", { position: "top-center", duration: 3000 });
          });
      }
    },

    // Suspend (-1) and Reject (-2) both go through the same generic status
    // endpoint, unlike verify/vet which have their own dedicated endpoints.
    updateClaimStatus(status, actionLabel) {
      if (!confirm(`Are you sure you want to ${actionLabel} this claim?`)) return;
      this.axios
        .post(`/api/v1/auth/updateClaim/${this.$route.params.id}`, { status })
        .then(() => {
          this.getClaim();
          this.$toasted.info(`Claim ${actionLabel}ed successfully!`, { position: "top-center", duration: 3000 });
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error(`Failed to ${actionLabel} claim.`, { position: "top-center", duration: 3000 });
        });
    },

    getSingleService(service) {
      this.singlservicemodal = service;
      this.calc = { dose: service.dose, frequency: service.frequency, days: service.days };
      this.modalVerdict = service.remark ? service.remark.id : "";
      this.modalCommentBody = "";
      this.showManualPrice = false;
    },

    printMe() {
      const printContents = document.getElementById("printDiv").innerHTML;
      const originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
    },

    addDrugDeductable() {
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/claim_service", {
          services_id: 2019,
          claims_id: this.$route.params.id,
          days: 1,
          dose: 1,
          frequency: 1,
          verified_price: -this.singleclaim.revised_fee,
        })
        .then(() => {
          this.getClaim();
          this.isLoading = false;
          this.$breadstick.notify("Added successfully!", { position: "top-right" });
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
        });
    },

    fetchClaimSummary() {
      this.summaryLoading = true;
      this.claimSummary = null;
      this.axios
        .get(`/api/v1/auth/claims/${this.$route.params.id}/summary-review`)
        .then((response) => {
          this.claimSummary = response.data.data;
          this.summaryLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.summaryLoading = false;
          this.$toasted.error("Failed to load summary.", { position: "top-center", duration: 3000 });
        });
    },

    resetAutoVet() {
      this.vetResults = null;
      this.hivaView = null;
      this.hivaForce = false;
      if (!this.canUseHiva) {
        this.vetLayers = this.vetLayers.filter((l) => l !== "C");
        return;
      }
      this.loadHivaHistory();
    },

    loadHivaHistory() {
      if (!this.canUseHiva) return;
      this.hivaHistoryLoading = true;
      this.axios
        .get(`/api/v1/auth/hiva/claims/${this.$route.params.id}/vettings`)
        .then((response) => {
          this.hivaHistory = response.data.data || [];
        })
        .catch(() => {
          this.hivaHistory = [];
        })
        .finally(() => {
          this.hivaHistoryLoading = false;
        });
    },

    viewHivaResult(vetting) {
      this.hivaView = this.hivaView && this.hivaView.id === vetting.id ? null : vetting;
    },

    // Name of the claim line a HIVA check refers to (details.line_id = claims_services.id).
    hivaLineName(chk) {
      const details = chk.details || {};
      if (details.service_name || details.drug_name) return details.service_name || details.drug_name;
      const lineId = Number(chk.claims_service_id || details.line_id);
      const line = lineId && this.singleclaim && this.singleclaim.services
        ? this.singleclaim.services.find((s) => s.id === lineId)
        : null;
      if (!line) return "";
      return line.drug ? line.drug.drug_name : (line.service ? line.service.description : "");
    },

    hivaBadge(status) {
      const s = String(status || "").toUpperCase();
      if (s === "PASS") return "badge badge-soft-success";
      if (s === "REJECT" || s === "FAIL") return "badge badge-soft-danger";
      if (s === "QUERY") return "badge badge-soft-warning";
      return "badge badge-soft-secondary";
    },

    runAutoVet() {
      if (!this.vetLayers.length) {
        this.$toasted.error("Select at least one layer.", { position: "top-center", duration: 3000 });
        return;
      }
      const withHiva = this.vetLayers.includes("C");
      if (withHiva && !this.hivaChecks.length) {
        this.$toasted.error("Select at least one HIVA TRACE check.", { position: "top-center", duration: 3000 });
        return;
      }
      this.vetLoading = true;
      this.vetResults = null;
      this.hivaView = null;
      const params = { layers: this.vetLayers };
      if (withHiva) {
        params.hiva_checks = this.hivaChecks;
        params.hiva_include_ai = this.hivaIncludeAi ? 1 : 0;
        params.hiva_force = this.hivaForce ? 1 : 0;
      }
      this.axios
        .get(`/api/v1/auth/claims/${this.$route.params.id}/auto-vet`, { params })
        .then((response) => {
          this.vetResults = response.data.data;
          this.vetLoading = false;
          const hivaError = this.vetResults.external_api_error;
          if (hivaError) {
            this.$toasted.error(hivaError.message, { position: "top-center", duration: 6000 });
          } else if (this.vetResults.hiva && this.vetResults.hiva.reused) {
            this.$toasted.info("Showing the HIVA TRACE result from " + this.vetResults.hiva.created_at + " (claim unchanged).", { position: "top-center", duration: 4000 });
          }
          if (withHiva) this.loadHivaHistory();
        })
        .catch((error) => {
          console.error(error);
          this.vetLoading = false;
          const message = error.response && error.response.data && error.response.data.message;
          this.$toasted.error(message || "Auto-vetting failed. Please try again.", { position: "top-center", duration: 4000 });
        });
    },

    applyAutoVet() {
      if (!this.vetResults) return;
      this.vetApplying = true;
      this.axios
        .post(`/api/v1/auth/claims/${this.$route.params.id}/auto-vet/apply`, {
          results: this.vetResults.results,
        })
        .then(() => {
          this.vetApplying = false;
          this.getClaim();
          this.$toasted.success("Auto-approved prices applied successfully!", { position: "top-center", duration: 3000 });
          document.getElementById("autoVetModal").querySelector('[data-dismiss="modal"]').click();
        })
        .catch((error) => {
          console.error(error);
          this.vetApplying = false;
          this.$toasted.error("Failed to apply vetting results.", { position: "top-center", duration: 3000 });
        });
    },
  },

  created() {
    this.getClaim();
  },
};
